<template>
  <div>
    <div class="fantan-number-bet-lot-cell">
      <Row
        class="fantan-number-bet-lot-title"
        :class="{ [size]: size }"
        type="flex"
        justify="center"
        align="middle"
      >
        <!-- <span v-html="(`${type}`)"></span> -->
        <span>{{ this.type.charAt(0) }}</span>
        <span>{{ this.type.charAt(1) }}</span>
        <span class="typecolor">{{ $t("fantan.nga") }}</span>
        <span class="typecolor">{{ this.type.charAt(5) }}</span>
      </Row>
      <Row
        class="fantan-number-bet-lot-bet-no"
        :class="{ [size]: size }"
        type="flex"
        justify="center"
        >{{ odd }}</Row
      >
      <div v-if="stakeRecordSum" class="fantan-number-bet-lot-stake-total">
        {{ stakeRecord }}
      </div>
    </div>
  </div>
</template>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: ["type", "odd", "game", "size", "stakeRecordSum"],
  components: {
    Row,
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    },
  },
};
</script>

<style lang="scss" scoped>
.fantan-number-bet-lot-cell {
  position: relative;
  // padding: 2px 0 3px;
  width: 100%;
  border-radius: 4px;
  // background: #2a2a2b;
  text-align: center;
}

.fantan-number-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.fantan-number-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.fantan-number-bet-lot-title {
  font-family: "Oswald";
  color: #fbfbfb;
  // text-transform: uppercase;
  font-weight: bold;
  margin: auto;
  font-size: 14px;
}

.typecolor {
  color: #fa4358;
}

.fantan-top .fantan-number-bet-lot-title,
.fantan-bottom .fantan-number-bet-lot-title {
  padding: 16px 0 0;
}

.fantan-number-bet-lot-title.small {
  height: unset;
}

.fantan-number-bet-lot-bet-no {
  // @extend .tai-xiu-game-bet-no;
  font-family: "Oswald";
  color: #ffffff;
  font-weight: bold;
  margin: auto;
  font-size: 12px;
  height: 20%;
}

.fantan-number-bet-lot-bet-no.small {
  height: unset;
}

.fantan-number-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-radius: 0 8px;
  max-height: 16px;
  line-height: 16px;
}
</style>